
export enum AppointmentNotificationStatCd {
	ACTIVE = 'Active',
	CANCELLED = 'Cancelled',
	DELIVERY_COMPLETED = 'DeliveryCompleted',
	INACTIVE = 'Inactive',
	NOT_NEEDED = 'NotNeeded',
	REMOVED_FROM_APPOINTMENT = 'RemovedFromAppointment',
	RESCHEDULED = 'Rescheduled',
	RETURN = 'Return'}

